import React, { useState } from 'react';
import { Box, Typography, IconButton } from '@mui/material';
import { ArrowBackIos, ArrowForwardIos } from '@mui/icons-material';
import './newUpdates.scss';

const latestNews = [
 // "5 Students requested extension",
 // "Mid sem starting next week ",
 // "2 students changed mentor",
 // "15 students thesis feedback pending"
];

const NewUpdates = () => {
    const [startIndex, setStartIndex] = useState(0);

    const handlePrev = () => {
      setStartIndex((prevIndex) =>
        Math.max(prevIndex - 1, 0)
      );
    };
  
    const handleNext = () => {
      setStartIndex((prevIndex) =>
        Math.min(prevIndex + 1, latestNews.length - 3)
      );
    };
  

  return (
    <div className="featured">
      <div>
        <ul className="pdf-list" >
          <li>
  Batch 2022 Grades:{" "}
  <a
    href="https://docs.google.com/spreadsheets/d/1DkzUbWoJzuMVjlcPf5k_Oi1LRzPAWGEOy-kXsqQ_Oac/edit?usp=sharing"
    target="_blank"
    rel="noopener noreferrer"
    style={{ color: 'red', textDecoration: 'underline' }}
  >
    Click here
  </a>
</li>
         <li>
  Batch 2023 Grades:{" "}
  <a
    href="https://docs.google.com/spreadsheets/d/1ol-emS4l_zsa8z2NRwnRyIh2fOuPDQBK/edit?usp=sharing&ouid=116959494378677223667&rtpof=true&sd=true"
    target="_blank"
    rel="noopener noreferrer"
    style={{ color: 'red', textDecoration: 'underline' }}
  >
    Click here
  </a>
</li>
 
       <li>
  Previous Batches Viva Schedules and Examiners List:{" "}
  <a
    href="https://docs.google.com/spreadsheets/d/1ao994kH5bd5QNZ-oUTOpCjk-8-2u4havmXElwTxHPiY/edit?usp=sharing"
    target="_blank"
    rel="noopener noreferrer"
    style={{ color: 'red', textDecoration: 'underline' }}
  >
    Click here
  </a>
</li>

<li>
            End Term Report Submission Date : <span style={{ color: 'red' }}>{'10th September, 2025'}</span>
          </li>
 
 <li>
            End Term Viva Dates : <span style={{ color: 'red' }}>{'24th and 25th September, 2025'}</span>
          </li>
 

        </ul>
      </div>
</div>



   
  )
}


export default NewUpdates;